@if (brandImg()) {
    <a [routerLink]="routerLink()">
        @if (brandFull()) {
            <img [sqHtmlAttributes]="brandFull()" [ngClass]="'sidebar-brand-full'" />
        }
        @if (brandNarrow()) {
            <img [sqHtmlAttributes]="brandNarrow()" [ngClass]="'sidebar-brand-narrow'" />
        }
    </a>
} @else {
    <ng-content />
}
